import { render, staticRenderFns } from "./FormulaCard.vue?vue&type=template&id=e338145a&scoped=true&"
import script from "./FormulaCard.vue?vue&type=script&lang=js&"
export * from "./FormulaCard.vue?vue&type=script&lang=js&"
import style0 from "./FormulaCard.vue?vue&type=style&index=0&id=e338145a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e338145a",
  null
  
)

export default component.exports